import joi from 'joi';
import { Record } from 'immutable';
import _ from 'lodash';

import { toImmutable } from '../../helpers/Immutable';
import ValidationMixin from '../ValidationMixin';
import validation from '../../validation';
import CountryStore from '../../stores/CountryStore';
import config from '../../config';

const SmartcardAddressName = 'Smartcard';

const defaults = {
    id: null,
    name: null,
    contactName: null,
    line1: null,
    line2: null,
    line3: null,
    town: null,
    postCode: null,
    country: config.get('defaultDeliveryCountry'),
    telephoneNumber: null,
    toSave: false,
    default: false,
};

class Address extends Record(defaults) { // eslint-disable-line new-cap

    static fromJSON(json = {}) {
        return new Address(json);
    }

    getSchema () {
        return {
            contactName: validation.requiredString(),
            line1: validation.addressLine().required(),
            line2: validation.textMaxLength(),
            line3: validation.textMaxLength(),
            town: validation.townCity(),
            postCode: joi.any().when('country', {
                 is: config.get('defaultDeliveryCountry'),
                 then: validation.postcode(),
                 otherwise: joi.any()
            }),
            country: validation.requiredString(),
            telephoneNumber: validation.phone().allow(null),
            name: joi.any().when('toSave', {
                 is: true,
                 then: validation.name(1, 50),
                 otherwise: joi.any()
            }),
            isDefault: joi.boolean().optional()
        };
    }

    reset (includeContactName = false) {
        const contactName = !includeContactName ? this.contactName : null;
        return new Address({ contactName });
    }

    isPostCodeRequired () {
        return this.country === defaults.country;
    }

    isDeliveryCountry () {
        return this.country === defaults.country;
    }

    isStored () {
        return !!this.id;
    }

    isSmartcardAddress () {
        return this.isStored() && this.name === SmartcardAddressName;
    }

    isEditable () {
        return this.isSmartcardAddress();
    }

    isDeletable () {
        return !this.isSmartcardAddress();
    }

    getCountryName () {
        return CountryStore.getCountry(this.country) && CountryStore.getCountry(this.country).name || this.country;
    }

    getUpdateRequestJSON() {
        return {
            "line1": this.line1,
            "line2": this.line2,
            "line3": this.line3,
            "town": this.town,
            "postCode": this.postCode,
            "default": this.default
        };
    }

    asList (includeContactName = true) {
        return toImmutable(_.compact([
            includeContactName && this.contactName,
            this.line1,
            this.line2,
            this.line3,
            this.town,
            this.postCode,
            this.getCountryName()
        ]));
    }

    toString () {
        return this.asList().join(', ');
    }
}

Object.assign(Address.prototype, ValidationMixin);

export default Address;



// WEBPACK FOOTER //
// ./src/records/customer/Address.js